import React, { useEffect, useState } from "react"

import Breadcrumbs from "../../../components/Common/Breadcrumb"
import { useDispatch, useSelector } from "react-redux"
import {
  getProviderIps,
  getProviderIpsStock,
  getProviderItemCategories,
  getProviderItems,
  getProviderStock,
} from "store/provider-dashboard/provider-dashboard-action"
import ProviderDashboardComponent from "components/ProviderDashboard/ProviderDashboardComponent"
import ProviderInventoryListComponent from "components/ProviderReports/Inventory"
import { exportProviderInventoryReport } from "store/provider-reports/p-report-action"
import useReportColumns from "hooks/useReportColumns"
import { REPORT_COLUMN_KEYS } from "config/reportColumnDefinitions"

const ProviderInventoryList = props => {
  //meta title
  document.title = "Dashboard"

  const [params, setParams] = useState({})
  const [fitlers, setFilters] = useState(null)
  const { columns, visibleColumns, visibleKeys, toggleColumn, moveColumnToIndex } = useReportColumns(
    REPORT_COLUMN_KEYS.PROVIDER_INVENTORY
  )
  const providerStock = useSelector(
    state => state.providerDashboard.providerStock
  )

  const dispatch = useDispatch()

  // Executes when the advanced search form is submitted
  const onSubmit = values => {
    setParams(values)
    dispatch(getProviderStock(values))
  }

  // Update the filter state with the new search values for providers
  const onProviderSearchHandler = values => {
    setFilters(values)
  }

  // Trigger export process when Export button is clicked
  const onExport = () => {
    dispatch(exportProviderInventoryReport(params, visibleKeys))
  }

  // store Item Categories and fetch items based item category
  const onCategoryChange = category => {
    dispatch(getProviderItems(category))
  }

  // fetch stock and other data based filter select box need
  useEffect(() => {
    dispatch(getProviderStock())
    dispatch(getProviderIps())
    dispatch(getProviderItemCategories())
  }, [])

  return (
    <React.Fragment>
      <Breadcrumbs title={"Provider"} breadcrumbItem={"Inventory"} />
      {/* Provider Inventory List Component  */}
      <ProviderInventoryListComponent
        provStock={providerStock?.data?.data?.providerReports}
        provData={providerStock?.data?.data}
        onSubmit={onSubmit}
        onCategoryChange={onCategoryChange}
        onExport={onExport}
        onProviderSearchHandler={onProviderSearchHandler}
        columns={columns}
        visibleColumns={visibleColumns}
        onToggleColumn={toggleColumn}
        onReorder={moveColumnToIndex}
      />
    </React.Fragment>
  )
}

export default ProviderInventoryList
